/* eslint-disable max-len */
import React from 'react';

export const LayoutListIconNew = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6.00748C4 5.45107 4.44463 5 5.00087 5H18.9991C19.5519 5 20 5.44892 20 6.00748V18.9925C20 19.5489 19.5554 20 18.9991 20H5.00087C4.44811 20 4 19.5511 4 18.9925V6.00748ZM5 6V19H19V6H5ZM9 9H17V10H9V9ZM9 12H17V13H9V12ZM9 15H17V16H9V15ZM7 9H8V10H7V9ZM7 12H8V13H7V12ZM7 15H8V16H7V15Z"
      fill="currentColor"
    />
  </svg>
);
